import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

// Crea estilos
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    padding: "15px",
  },
  section: {
    margin: "10px",
    padding: "10px",
    flexGrow: 1,
  },
  header: {
    marginBottom: "10px",
  },
  texto: {
    marginBottom: "10px",
    fontSize: "16px",
  },
});

const SolicitudPDF = ({ cliente }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <Text style={styles.header}>Solicitud Servicio Especial:</Text>
        <Text style={styles.texto}>
          Fecha:{" "}
          {new Date(
            new Date(cliente.fecha).toLocaleString("en-US", { timeZone: "UTC" })
          ).toLocaleDateString("es-ES")}
        </Text> 
        <Text style={styles.texto}>N° {cliente.docId}</Text>
        <Text style={styles.texto}>Empresa: {cliente.empresa}</Text>
        <Text style={styles.texto}>Teléfono: {cliente.telefono}</Text>
        <Text style={styles.texto}>Email: {cliente.email}</Text>
        <Text style={styles.texto}>
          Fecha de salida:{" "}
          {new Date(
            new Date(cliente.fechaSalida).toLocaleString("en-US", {
              timeZone: "UTC",
            })
          ).toLocaleDateString("es-ES")}{" "}
          {cliente.horaSalida
            ? " - Hora: " + cliente.horaSalida
            : "- Hora: Sin especificar"}
        </Text>
        <Text style={styles.texto}>
          Cantidad de pasajeros: {cliente.cantidadPasajeros}
        </Text>
        <Text style={styles.texto}>Lugar de salida: {cliente.lugarSalida}</Text>
        <Text style={styles.texto}>
          Lugar de destino: {cliente.lugarDestino}
        </Text>
        <Text style={styles.texto}>
          Tipo de servicio: {cliente.tipoServicio}
        </Text>
        <Text style={styles.texto}>
          Fecha de regreso:{" "}
          {new Date(
            new Date(cliente.fechaRegreso).toLocaleString("en-US", {
              timeZone: "UTC",
            })
          ).toLocaleDateString("es-ES")}{" "}
          {cliente.horaRegreso
            ? " - Hora: " + cliente.horaRegreso
            : "- Hora: Sin especificar"}
        </Text>
        <Text style={styles.texto}>Observaciones: {cliente.observaciones}</Text>
      </View>
    </Page>
  </Document>
);

export default SolicitudPDF;
